export const CREATE_EAP_SETTING_REST_ENDPOINT = 'api/v1/eap-setting';
export const UPDATE_EAP_SETTING_REST_ENDPOINT = 'api/v1/eap-setting';
export const IMPORT_EAP_SETTINGS_REST_ENDPOINT = 'api/v1/eap-settings/import';

export interface EapSettingsPayload {
    name: string;
    ssid: string;
    cipherType: string;
    eapType: string;
    anonymousUser: string;
    username: string;
    caCertificateFilename: string;
    clientCertificateFilename: string;
    clientPrivateKeyFilename: string;
    password: string;
}

export interface UpdateEapSettingsPayload extends Omit<EapSettingsPayload, 'name'> {
    id: string;
}

export interface CreateEapSettingsApiRequest {
    eapContent: EapSettingsPayload;
    caCertificate?: File;
    clientCertificate?: File;
    clientPrivateKey?: File;
}

export interface UpdateEapSettingsApiRequest {
    eapContent: UpdateEapSettingsPayload;
    caCertificate?: File;
    clientCertificate?: File;
    clientPrivateKey?: File;
}

export type EapImportNamingStrategy = 'FILE' | 'PREFIX';

export interface ImportEapSettingsPayloadItem {
    name: string;
    serialNumber: string;
    ssid: string;
    cipherType: string;
    eapType: string;
    anonymousUser: string;
    username: string;
    caCertificateFilename: string;
    clientCertificateFilename: string;
    privateKeyFilename: string;
    password: string;
    privateKeyPassword: string;
}

export interface ImportEapSettingsApiRequest {
    namingStrategy: EapImportNamingStrategy;
    eapContent: ImportEapSettingsPayloadItem[];
    caCertificates?: File[];
    clientCertificates?: File[];
    privateKeys?: File[];
}
